import React, { useState, useEffect } from 'react';

import './styles.css';

import studentsServices from '../../../services/academy/studentsServices';

import { months } from '../../../functions/formatDate';
import loadTextTest from '../../../functions/loadTextTest';

import MainView from '../../../components/MainView';
import HomeCard from '../../../components/HomeCard';
import { Link } from 'react-router-dom';
import { FaUser, FaBell, FaFutbol, FaDollarSign } from 'react-icons/fa';
import UserPhoto from '../../../components/UserPhoto';

function Home() {
    const [studentInfos, setStudentInfos] = useState({});
    // const [fetching, setFetching] = useState(true);
    const [nextTraining, setNextTraining] = useState({});
    const [dueDate, setDueDate] = useState([]);

    useEffect(() => {
        readStudentInfos();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    async function readStudentInfos() {
        const id = localStorage.getItem("_id");
        const response = await studentsServices.getStudentInfos(id);
        // setFetching(false);
        if (response.status === 200) {
            setStudentInfos(response.data);
            localStorage.setItem("_studentInfos", JSON.stringify(response.data));
            setNextTraining(response.data.proximo_treino ? response.data.proximo_treino : null);
            setDueDate(response.data.pagamento ? response.data.pagamento.split('-').reverse() : null);
        } else
            alert("Erro ao ler informações de aluno, tente novamente!");
    }

    function formatDateInfo(date) {
        let auxDate = new Date();
        auxDate.setHours(auxDate.getHours() - (auxDate.getTimezoneOffset()/60));

        if (date === auxDate.toISOString().slice(0, 10))
            return "Hoje";

        auxDate.setDate(auxDate.getDate() + 1);
        if (date === auxDate.toISOString().slice(0, 10))
            return "Amanhã";

        auxDate.setDate(auxDate.getDate() + 1);
        if (date === auxDate.toISOString().slice(0, 10))
            return "Em 2 dias";

        auxDate = date.split('-').reverse();
        return `${auxDate[0]} de ${months[auxDate[1] - 1]}`;
    }

    return (
        <MainView currentPage='home' studentMenu>
            <div className='student-home-page-message'>
                <h2>Bem vindo ao</h2>
                <h1>PORTAL <b>Boston</b>City</h1>
            </div>
            <hr />
            <div className='student-home-page-user'>
                <div className='student-home-page-user-infos'>
                    <UserPhoto alt='Foto de perfil do usuário' src={studentInfos.foto} />
                    <div className='student-home-page-user-infos-texts'>
                        <h3>Olá, <b>{loadTextTest(studentInfos.nome)}</b>!</h3>
                    </div>
                </div>
                <div className='student-home-page-user-options'>
                    <Link to='/aluno/perfil' className='button'>Meu perfil<FaUser /></Link>
                    <Link to='/aluno/notificacoes' className='button'>Nofificações<FaBell /></Link>
                </div>
            </div>
            <div className='student-home-page-cards'>
                <HomeCard
                    to='/aluno/perfil'
                    title={<>Próximo <b>treino</b></>}
                    data={nextTraining ?
                            loadTextTest(nextTraining.data ? `${formatDateInfo(nextTraining.data)}, às ${nextTraining.hora_inicio.slice(0, 5)}` : null)
                            : "Não há próximo treino"
                        }
                    icon={<FaFutbol />}
                />
                <HomeCard
                    to='/aluno/perfil'
                    title={<><b>Vencimento</b></>}
                    data={dueDate ?
                        loadTextTest(dueDate.length ? `${dueDate[0]} de ${months[dueDate[1] - 1]}` : null)
                        : "Não há matricula em aberto"
                    }
                    icon={<FaDollarSign />}
                />
            </div>
        </MainView>
    )
}

export default Home;